import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import type { Socket } from 'socket.io-client';

/**
 * Quando o socket reconecta (ex.: após deploy blue-green), invalida as queries
 * passadas. Em socket.io-client v4 o evento `reconnect` é emitido pelo Manager
 * (`socket.io`), não pelo Socket — por isso escutamos em `socket.io`.
 */
export function useSocketReconnect(
  socket: Socket | null | undefined,
  queryKeysToInvalidate: Array<string | ReadonlyArray<string | number>>,
) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!socket) return;

    const handler = () => {
      queryKeysToInvalidate.forEach((key) => {
        queryClient.invalidateQueries(key);
      });
    };

    socket.io.on('reconnect', handler);
    return () => {
      socket.io.off('reconnect', handler);
    };
  }, [socket, queryClient, queryKeysToInvalidate]);
}
